import CheckIcon from '@mui/icons-material/Check';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import { Card, Grid, Badge, Avatar, Box, Typography, Stack } from '@mui/material';
import dayjs from 'dayjs';
import { AiFillFilePdf } from 'react-icons/ai';
import {
  WsColors,
  WsTypoVariants,
  WsIconText,
  WsIconDateOutline,
  WsIconLocation,
  WsIconJobOutline,
} from 'wisestep-base';

import { trackCV, downloadCV } from '../../../utils/cvHelper';

export interface CvCardProps {
  title: string | null;
  source: string;
  date?: string | null;
  resumeUrl?: string | null;
  jobTitle?: string;
  jobcode?: string;
  recruiterName?: string;
  onClick?: () => void;
  isSelected: boolean;
}

const CvCard = ({
  title,
  source,
  date,
  jobcode,
  resumeUrl,
  jobTitle,
  recruiterName,
  onClick = () => {},
  isSelected,
}: CvCardProps) => {
  const formattedDate = (date: string | null | undefined = null): string => {
    if (date) {
      return dayjs(date).format('DD-MM-YYYY HH:mm');
    }
    return '';
  };
  const CvDownload = () => {
    if (resumeUrl) {
      trackCV('download', resumeUrl);
      downloadCV(resumeUrl, title as string);
    }
  };
  return (
    <Box m={1} p={2}>
      <Badge
        badgeContent={
          <Avatar sx={{ bgcolor: WsColors.TheBlues500, width: 20, height: 20 }}>
            <CheckIcon fontSize="small" />
          </Avatar>
        }
        invisible={!isSelected}
        sx={{ width: '100%', font: '8px' }}
      >
        <Card
          sx={{
            width: '100%',
          }}
          onClick={onClick}
        >
          <Box
            sx={{
              border: 'solid 1px',
              borderRadius: '1px',
              backgroundColor: isSelected ? WsColors.TheBlue75 : WsColors.White,
              borderColor: isSelected ? WsColors.TheBlues300 : WsColors.BorderGrey,
              width: '100%',
              padding: 2,
            }}
          >
            <Grid container item alignItems="center" display="flex" justifyContent="space-between">
              <Stack alignItems="center" direction="row" sx={{ maxWidth: 'calc(100% - 40px)' }}>
                <Box sx={{ flex: 1 }}>
                  <AiFillFilePdf color="red" />
                </Box>
                <Typography
                  sx={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {title ? `${title.substring(0, title.length)}...` : ''}
                </Typography>
              </Stack>
              <Box onClick={CvDownload}>
                <FileDownloadOutlinedIcon sx={{ color: WsColors.TheBlues500 }} />
              </Box>
            </Grid>
            <Grid mt={1} ml={'8px'}>
              <WsIconText
                icon={<WsIconJobOutline color={WsColors.TertiaryShades500} />}
                text={`${jobTitle} ${jobcode ? `(${jobcode ?? ''})` : ''}`}
                textSize={WsTypoVariants.BODY1}
                opacity={true}
                popOverText={`job Title(job code)`}
                textCursor="pointer"
              />
            </Grid>
            <Grid mt={1} ml={'8px'}>
              <WsIconText
                icon={<WsIconLocation color={WsColors.TertiaryShades500} />}
                text={`${recruiterName ?? ''}`}
                textSize={WsTypoVariants.BODY1}
                opacity={true}
                popOverText={`Created By`}
                textCursor="pointer"
              />
            </Grid>
            <Grid mt={1} ml={'8px'}>
              <WsIconText
                icon={<TravelExploreIcon sx={{ color: WsColors.TertiaryShades500 }} />}
                text={`${source ?? ''}`}
                textSize={WsTypoVariants.BODY1}
                opacity={true}
                popOverText={`source`}
                textCursor="pointer"
              />
            </Grid>
            <Grid mt={1} ml={'8px'}>
              <WsIconText
                icon={<WsIconDateOutline color={WsColors.TertiaryShades500} />}
                text={`${formattedDate(date) ?? ''}`}
                textSize={WsTypoVariants.BODY1}
                opacity={true}
                popOverText={`uploaded on`}
                textCursor="pointer"
              />
            </Grid>
          </Box>
        </Card>
      </Badge>
    </Box>
  );
};

export default CvCard;
